// MDBootstrapをカスタムする時の追加用ファイル
import $ from "jquery"

// Popovers https://mdbootstrap.com/docs/standard/components/popovers/
$(function () {
  $('[data-toggle="popover"]').popover()
})
// End Popovers
